module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash/extend.js
// module id = 91
// module chunks = 18